(function () {
    'use strict';

    function main() {
        var page = wo$('#home');
        if (!page.length) return;

        var controller = {
            init: function () {
                WhistleOut.getAds('PayTv');
            }
        };

        controller.init();
    }

    WhistleOut.initModule(import.meta.url, main);
})();
